import React from 'react'

import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import { setOpenEventDetails } from '../../store/calendarSlice'
import {
  CrudPanelCloseIcon,
  CrudPanelTitle,
  CrudPanelTitleWrapper,
} from '../sharedStyle'

interface IProps {
  panelTitle: string | null
}

export const NavigationTitle = ({ panelTitle }: IProps) => {
  const dispatch = useAppDispatch()
  const handlePanelClose = () =>
    dispatch(
      setOpenEventDetails({
        openFormDetails: { type: 'idle', event: null },
      }),
    )
  return (
    <CrudPanelTitleWrapper extraMargin>
      <CrudPanelTitle>{panelTitle}</CrudPanelTitle>
      <CrudPanelCloseIcon icon="xmark" onClick={handlePanelClose} />
    </CrudPanelTitleWrapper>
  )
}
